/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The LoginUserDeliveryGroup model module.
* @module model/LoginUserDeliveryGroup
* @version 2020-12-7
*/
export default class LoginUserDeliveryGroup {
    /**
    * Constructs a new <code>LoginUserDeliveryGroup</code>.
    * @alias module:model/LoginUserDeliveryGroup
    * @class
    * @param id {Number} 
    * @param name {String} 
    */

    constructor(id, name) {
        
        
        this['id'] = id;
        this['name'] = name;
        
    }

    /**
    * Constructs a <code>LoginUserDeliveryGroup</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/LoginUserDeliveryGroup} obj Optional instance to populate.
    * @return {module:model/LoginUserDeliveryGroup} The populated <code>LoginUserDeliveryGroup</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LoginUserDeliveryGroup();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * @member {String} name
    */
    'name' = undefined;




}
